/**
 * Sleek's flat pill surface (partner Figma 2026-10-06: no glass, a solid
 * Background/Neutral/Subtler fill with a hairline border). Shared by the
 * header pills — Vault, lobby X, category dropdown and balance — so the
 * Constructor themes them as one `SleekHeaderPill`. The text colour also
 * paints the pills' icons, which draw in `currentColor`.
 */
export const SLEEK_PILL_SURFACE =
  'rounded-[60px] border border-solid ' +
  '[border-color:var(--co-SleekHeaderPill-border,rgba(255,255,255,0.01))] ' +
  'bg-[var(--co-SleekHeaderPill-fill,#1A1B1F)] text-[var(--co-SleekHeaderPill-text,#FFFFFF)]';

/**
 * Sleek's sticky header once content scrolls under it — lobby, Vault and
 * What's inside share it as one `SleekHeaderBar`. Standard `backdrop-filter`
 * only: the CSS pipeline adds the `-webkit-` prefix (see `.stats-row-card`
 * in index.css for why a hand-written one breaks the minified bundle).
 */
export const SLEEK_HEADER_SCROLLED =
  'border-b bg-[var(--co-SleekHeaderBar-scrolledFill,rgba(0,0,0,0.4))] ' +
  '[border-color:var(--co-SleekHeaderBar-scrolledBorder,rgba(255,255,255,0.1))] ' +
  '[backdrop-filter:blur(var(--co-SleekHeaderBar-scrolledBlur,12px))]';
